import { Action } from '../actions/types'

export type VisualizationState = {
  readonly modelRequestId: string | undefined
}

const initialState: VisualizationState = {
  modelRequestId: undefined
}

const reducer = (
  state: VisualizationState = initialState,
  action: Action
): VisualizationState => {
  switch (action.type) {
    case 'SET_BEAM_REQUEST_ID':
      return { ...state, modelRequestId: action.payload }

    case 'CLEAR_BEAM_REQUEST':
      return { ...state, modelRequestId: undefined }

    case 'USER_LOGOUT':
      return initialState

    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/reducers/visualization.ts